// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React from 'react';
import ReportsIcon from '@styles/webdesktop/Icons/reportsIcon.svg';
import ChartIcon from '@styles/webdesktop/Icons/chartIcon.svg';
import ChartTV from '@styles/webdesktop/Icons/chartTV.svg'; // TradingView
import WatchListIcon from '@styles/webdesktop/Icons/watchListIcon.svg';
import TimeAndSalesIcon from '@styles/webdesktop/Icons/timeAndSalesIcon.svg';
import GridIcon from '@styles/webdesktop/Icons/gridIcon.svg';
import TradingTools from '@styles/webdesktop/Icons/tradingTools.svg';
import OrderEntry from '@styles/webdesktop/Icons/orderEntry.svg';
import OptionMaster from '@styles/webdesktop/Icons/optionMaster.svg';
import SavedOrder from '@styles/webdesktop/Icons/savedOrder.svg';
import MarketDepth from '@styles/webdesktop/Icons/marketDepth.svg';
import PositionsIcon from '@styles/webdesktop/Icons/positionsIcon.svg';
import WorkingOrder from '@styles/webdesktop/Icons/workingOrder.svg';
import OrderHistory from '@styles/webdesktop/Icons/orderHistory.svg';
import FilledOrder from '@styles/webdesktop/Icons/filledOrder.svg';
import AssetIcon from '@styles/webdesktop/Icons/assetIcon.svg';
import PositionBalance from '@styles/webdesktop/Icons/positionBalance.svg';
import NewsIcon from '@styles/webdesktop/Icons/newsIcon.svg';
import StatementIcon from '@styles/webdesktop/Icons/statementIcon.svg';
import HeatMapIcon from '@styles/webdesktop/Icons/heatMapIcon.svg';
import HighLowList from '@styles/webdesktop/Icons/highLowList.svg';
import GainersLosers from '@styles/webdesktop/Icons/gainersLosers.svg';
import AboutIcon from '@styles/webdesktop/Icons/aboutIcon.svg';
import BrokerInfo from '@styles/webdesktop/Icons/brokerInfoIcon.svg';
import OnboardingIcon from '@styles/webdesktop/Icons/onboardingIcon.svg';
import DownloadLogFile from '@styles/webdesktop/Icons/downloadLogFile.svg';
import HomePage from '@styles/webdesktop/Icons/homePage.svg';
import TradingCentral from '@styles/webdesktop/Icons/tradingCentral.svg';
import LiveAccount from '@styles/webdesktop/Icons/liveAccount.svg';
import RiskCalculator from '@styles/webdesktop/Icons/riskCalculator.svg';
import ChangePasswordIcon from '@styles/webdesktop/Icons/changePassowordIcon.svg';
import WithdrawalIcon from '@styles/webdesktop/Icons/withdrawalIcon.svg';
import SubscriptionsIcon from '@styles/webdesktop/Icons/subscriptionsIcon.svg';
import AccountStatistics from '@styles/webdesktop/Icons/accountStatistics.svg';
import CopyTrading from '@styles/webdesktop/Icons/copyTrading.svg';
import ChangeTradingPassword from '@styles/webdesktop/Icons/changeTradingPassword.svg';
import CloseAccount from '@styles/webdesktop/Icons/closeAccount.svg';
import AccountLookup from '@styles/webdesktop/Icons/accountLookup.svg';
import Webhooks from '@styles/webdesktop/Icons/webhooks.svg';
import { StringUtils } from '@shared/utils/StringUtils';
import { ControlsUtils } from '../../UtilsClasses/ControlsUtils';
import { Font } from '@shared/commons/Graphics';
import { MenuIcons } from '@shared/utils/Enums/MenuIcons';
const TEXT_ICON_SIZE = 8;
const TEXT_ICON_FONT = new Font(TEXT_ICON_SIZE, 'Trebuchet MS, Arial, sans-serif', 'bold');
class _IconsFactory {
    getIcon(iconType) {
        switch (iconType) {
            case MenuIcons.ChartIcon:
                return React.createElement(ChartIcon, null);
            case MenuIcons.ChartTV:
                return React.createElement(ChartTV, null);
            case MenuIcons.WatchListIcon:
                return React.createElement(WatchListIcon, null);
            case MenuIcons.TimeAndSalesIcon:
                return React.createElement(TimeAndSalesIcon, null);
            case MenuIcons.GridIcon:
                return React.createElement(GridIcon, null);
            case MenuIcons.TradingTools:
                return React.createElement(TradingTools, null);
            case MenuIcons.OrderEntry:
                return React.createElement(OrderEntry, null);
            case MenuIcons.OptionMaster:
                return React.createElement(OptionMaster, null);
            case MenuIcons.SavedOrder:
                return React.createElement(SavedOrder, null);
            case MenuIcons.MarketDepth:
                return React.createElement(MarketDepth, null);
            case MenuIcons.PositionsIcon:
                return React.createElement(PositionsIcon, null);
            case MenuIcons.WorkingOrder:
                return React.createElement(WorkingOrder, null);
            case MenuIcons.OrderHistory:
                return React.createElement(OrderHistory, null);
            case MenuIcons.FilledOrder:
                return React.createElement(FilledOrder, null);
            case MenuIcons.AssetIcon:
                return React.createElement(AssetIcon, null);
            case MenuIcons.PositionBalance:
                return React.createElement(PositionBalance, null);
            case MenuIcons.News:
                return React.createElement(NewsIcon, null);
            case MenuIcons.StatementIcon:
                return React.createElement(StatementIcon, null);
            case MenuIcons.HeatMapIcon:
                return React.createElement(HeatMapIcon, null);
            case MenuIcons.HighLowList:
                return React.createElement(HighLowList, null);
            case MenuIcons.GainersLosers:
                return React.createElement(GainersLosers, null);
            case MenuIcons.AboutIcon:
                return React.createElement(AboutIcon, null);
            case MenuIcons.BrokerInfo:
                return React.createElement(BrokerInfo, null);
            case MenuIcons.OnboardingIcon:
                return React.createElement(OnboardingIcon, null);
            case MenuIcons.DownloadLogFile:
                return React.createElement(DownloadLogFile, null);
            case MenuIcons.HomePage:
                return React.createElement(HomePage, null);
            case MenuIcons.TradingCentral:
                return React.createElement(TradingCentral, null);
            case MenuIcons.CopyTrading:
                return React.createElement(CopyTrading, null);
            case MenuIcons.LiveAccount:
                return React.createElement(LiveAccount, null);
            case MenuIcons.RiskCalculator:
                return React.createElement(RiskCalculator, null);
            case MenuIcons.ReportsIcon:
                return React.createElement(ReportsIcon, null);
            case MenuIcons.ChangePasswordIcon:
                return React.createElement(ChangePasswordIcon, null);
            case MenuIcons.WithdrawalIcon:
                return React.createElement(WithdrawalIcon, null);
            case MenuIcons.SubscriptionsIcon:
                return React.createElement(SubscriptionsIcon, null);
            case MenuIcons.AccountStatistics:
                return React.createElement(AccountStatistics, null);
            case MenuIcons.ChangeTradingPassword:
                return React.createElement(ChangeTradingPassword, null);
            case MenuIcons.CloseAccount:
                return React.createElement(CloseAccount, null);
            case MenuIcons.AccountLookup:
                return React.createElement(AccountLookup, null);
            case MenuIcons.Webhooks:
                return React.createElement(Webhooks, null);
            default:
                return null;
        }
    }
    getIconByType(iconType, text) {
        var _a;
        return (_a = this.getIcon(iconType)) !== null && _a !== void 0 ? _a : this.generateSvgIcon(text);
    }
    generateSvgIcon(text) {
        const shortName = StringUtils.getAbbreviateText(text);
        const fontFamily = 'Trebuchet MS, Arial, sans-serif';
        const fontSize = TEXT_ICON_SIZE;
        const textWidth = ControlsUtils.GetTextWidth(shortName, TEXT_ICON_FONT);
        const x = (16 - textWidth) / 2;
        const letterSpacing = x < 2 ? -Math.abs(x) : 0;
        return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("rect", { x: "1.5", y: "0.5", width: "13", height: "15", rx: "1", stroke: "currentColor", fill: "none" }),
            React.createElement("text", { x: x, y: "11", letterSpacing: letterSpacing, fontSize: fontSize, fontFamily: fontFamily, fontWeight: "bold", fill: "currentColor" }, shortName)));
    }
}
export const IconsFactory = new _IconsFactory();
